export default __webpack_public_path__ + "static/media/alertIconpng.029045d0.png";